import { useRouter } from 'vue-router'
import { useRuntimeConfig } from '#app'
import { useDevice } from '#imports'
import type { ContactItem } from '~/utils/interface'
import { CONTACT_TYPE } from '~/constants'
import { copyString } from '~/utils'

export function useCommon() {
  const runTimeConfig = useRuntimeConfig()
  const { isMobile } = useDevice()
  const router = useRouter()
  const valueCopied = ref('')

  function openLinkNewTab(item: ContactItem): void {
    let newTab: Window | null
    if (item.link) {
      void router.push(item.link)
    }
    if (item.isNewTab) {
      newTab = window.open('', '_blank')
      if (newTab) {
        newTab.location.href = item.link ?? ''
      }
    }
  }
  const openLiveChat = (): void => {
    if (isMobile) {
      const openNewTab = window.open('about:blank', '_blank')
      if (openNewTab) {
        openNewTab.location.href = runTimeConfig.public.LIVE_CHAT_LINK
      }
    } else {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const newWindow: any = window
      newWindow.LiveChatWidget.call('maximize')
    }
  }

  const openLinkContact = (item: ContactItem): void => {
    if (item.type === CONTACT_TYPE.LIVECHAT) {
      openLiveChat()
      return
    }
    openLinkNewTab(item)
  }
  const onCopy = (value: string): void => {
    valueCopied.value = value
    void copyString(value)
  }
  return {
    valueCopied,
    openLiveChat,
    openLinkContact,
    onCopy
  }
}
